import './footer.styles.css';
import config from '../data/config.json';
import { Link } from 'react-router-dom';
import { FaPhoneAlt, FaEnvelope, FaFacebook, FaMapMarkerAlt } from 'react-icons/fa';
import IconComponent from '../IconComponent';

// get tagline from config
const name = config.name;
const tagline = config.tagline;

const Footer = () => {
  return (
    <footer className="pt-5 pb-4 bg-darker-blue text-black">
      <div className="container">
        <div className="footer-row d-flex flex-column flex-lg-row justify-content-between flex-wrap">
          {/* Column 1 */}
          <div className="col-12 col-lg footer-col mb-4 mb-lg-0">
            <h5 className="mb-3">{name}</h5>
            <p>{tagline}</p>
          </div>

          {/* Column 2 */}
          <div className="col-12 col-lg footer-col legal-links mb-4 mb-lg-0">
            <ul className="list-unstyled">
              <li>
                <Link to="/legal">Legal</Link>
              </li>
              <li>
                <Link to="/privacy">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/terms-and-conditions">Terms & Conditions</Link>
              </li>
              <li>
                <Link to="/refund-policy">Refund Policy</Link>
              </li>
            </ul>
          </div>

          {/* Column 3 */}
          <div className="col-12 col-lg footer-col mb-4 mb-lg-0">
            <h6 className="mb-3">Operating Hours</h6>
            <ul className="list-unstyled">
              <li>Mon - Fri: 8am - 8pm</li>
              <li>Saturday: 9am - 7pm</li>
              <li>Sunday: Closed</li>
            </ul>
          </div>

          {/* Column 4 (Contact) */}
          <div className="col-12 col-lg footer-col footer-contact-col">
            <h6 className="mb-3">Contact</h6>
            <p className="mb-2">I'm Your Huckleberry</p>
            <p className="mb-2">Katie Hartman</p>
            <ul className="list-unstyled">
              <li className="d-flex align-items-center mb-1">
                <IconComponent icon={FaMapMarkerAlt} />
                <span className="ms-2">1900 Babcock Avenue, Cumberland, WI 54829</span>
              </li>
              <li className="d-flex align-items-center mb-1">
                <a
                  href="tel:+17156518170"
                  className="text-decoration-none d-flex align-items-center"
                >
                  <IconComponent icon={FaPhoneAlt} />
                  <span className="ms-2">715-651-8170</span>
                </a>
              </li>
              <li className="d-flex align-items-center mb-1">
                <a
                  href="mailto:huckleberryhandyhomecleaning@gmail.com"
                  className="text-decoration-none d-flex align-items-center"
                >
                  <IconComponent icon={FaEnvelope} />
                  <span className="ms-2">huckleberryhandyhomecleaning@gmail.com</span>
                </a>
              </li>
              <li className="d-flex align-items-center">
                <a
                  href="https://www.facebook.com/profile.php?id=61575332424434"
                  className="text-decoration-none d-flex align-items-center"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <IconComponent icon={FaFacebook} />
                  <span className="ms-2">Facebook</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <hr className="border-secondary mt-4" />
        <div className="text-center small">
          &copy; {new Date().getFullYear()} Huckleberry Cleaning. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
